import { render, staticRenderFns } from "./PermissionUser.vue?vue&type=template&id=7fef3eb8&scoped=true&"
import script from "./PermissionUser.vue?vue&type=script&lang=js&"
export * from "./PermissionUser.vue?vue&type=script&lang=js&"
import style0 from "./PermissionUser.vue?vue&type=style&index=0&id=7fef3eb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fef3eb8",
  null
  
)

export default component.exports